import React from 'react';
import { translate } from '@utils/i18n';
import { Tag } from '@ui/atoms/Tag';
import ActionButtons from './components/ActionButtons';
// Cell components for grid columns
const badgeNamespace = 'features.ai_to_review_inspections.index.columns';
// IP-14530: IPA peer-job risk rating badge. Color is paired with text so the
// signal does not rely on color alone (WCAG 1.4.1).
const RISK_VARIANT = {
    critical: 'red',
    high_risk: 'red',
    medium_risk: 'yellow',
    low_risk: 'green'
};
export function RiskCell({ dataItem }) {
    var _a;
    const rating = dataItem.riskRating;
    if (!rating)
        return React.createElement("td", null, "\u2014");
    return (React.createElement("td", { className: "ia-review-badge-cell" },
        React.createElement(Tag, { label: translate(`risk_rating.${rating}`, { namespace: badgeNamespace, defaultValue: rating }), variant: (_a = RISK_VARIANT[rating]) !== null && _a !== void 0 ? _a : 'gray', colorStyle: "solid", readOnly: true })));
}
// IP-14532: deterministic frequency-compliance badge.
const COMPLIANCE_VARIANT = {
    overdue: 'red',
    needs_review: 'yellow',
    compliant: 'green'
};
export function ComplianceCell({ dataItem }) {
    var _a;
    const status = dataItem.complianceStatus;
    if (!status)
        return React.createElement("td", null, "\u2014");
    return (React.createElement("td", { className: "ia-review-badge-cell" },
        React.createElement(Tag, { label: translate(`compliance_status.${status}`, { namespace: badgeNamespace, defaultValue: status }), variant: (_a = COMPLIANCE_VARIANT[status]) !== null && _a !== void 0 ? _a : 'gray', colorStyle: "solid", readOnly: true })));
}
export function InspectionIdCell({ dataItem }) {
    return (React.createElement("td", null,
        React.createElement("a", { href: `/inspections/${dataItem.inspectionId}#iim-issues`, target: "_blank", rel: "noopener noreferrer" }, dataItem.inspectionId)));
}
export function BuildingCell({ dataItem }) {
    return (React.createElement("td", null,
        React.createElement("a", { href: `/buildings/${dataItem.buildingId}`, target: "_blank", rel: "noopener noreferrer" }, dataItem.building)));
}
export function InspectionStatusCell({ dataItem }) {
    const { inspectionStatusLabel, inspectionStatusIcon, inspectionStatusColor } = dataItem;
    if (!inspectionStatusLabel)
        return React.createElement("td", null);
    return (React.createElement("td", { style: { whiteSpace: 'nowrap' } },
        React.createElement("i", { className: `fa-lg ${inspectionStatusIcon}`, style: { color: inspectionStatusColor !== null && inspectionStatusColor !== void 0 ? inspectionStatusColor : undefined } }),
        "\u00A0",
        inspectionStatusLabel));
}
export function ActionsCell({ dataItem }) {
    return (React.createElement("td", null,
        React.createElement(ActionButtons, { inspection: dataItem })));
}
